<app-page-header
  title="Feedback Übersicht"
  subtitle="Analysiere Kundenrückmeldungen und erkenne Trends in der Zufriedenheit."
  icon="assessment"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-slide-up">
  <div class="apple-card apple-feedback-table-card">
    <div class="table-header">
      <div class="table-title">
        <mat-icon>insights</mat-icon>
        <span>Feedback Liste</span>
      </div>
      <div class="table-meta apple-caption" *ngIf="feedback$ | async as feedback">
        {{ feedback.length }} Einträge
      </div>
    </div>

    <div class="table-wrapper">
      <table
        mat-table
        [dataSource]="(feedback$ | async) ?? []"
        class="apple-feedback-table"
      >
        <!-- Customer Column -->
        <ng-container matColumnDef="customer">
          <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">
            <mat-icon>person</mat-icon>
            Kunde
          </th>
          <td mat-cell *matCellDef="let element" class="apple-table-cell">
            <div class="customer-cell">
              <div class="avatar-circle">
                {{ getCustomerName(element) | slice:0:1 }}
              </div>
              <span class="customer-name">{{ getCustomerName(element) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Text Column -->
        <ng-container matColumnDef="text">
          <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell">
            <mat-icon>chat_bubble_outline</mat-icon>
            Feedback
          </th>
          <td mat-cell *matCellDef="let element" class="apple-table-cell feedback-text">
            {{ element.feedbackText }}
          </td>
        </ng-container>

        <!-- Rating Column -->
        <ng-container matColumnDef="rating">
          <th mat-header-cell *matHeaderCellDef class="apple-table-header-cell rating-header">
            <mat-icon>star_rate</mat-icon>
            Bewertung
          </th>
          <td mat-cell *matCellDef="let element" class="apple-table-cell rating-cell">
            <span class="rating-badge" [ngClass]="getRatingColor(element.rating?.value)">
              {{ element.rating?.value }}/5
            </span>
            <span class="rating-stars" [ngClass]="getRatingColor(element.rating?.value)">
              <ng-container *ngFor="let star of getStars(element.rating?.value)">
                <mat-icon>{{ star ? 'star' : 'star_border' }}</mat-icon>
              </ng-container>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="apple-table-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="apple-table-row"></tr>
      </table>
    </div>
  </div>
</div>
